const tw = {
  LAYOUT: {
    SEND: "送出",
    CORS: "連接到服務器失敗，請稍後再嘗試(CORS)",
    NEXT_PAGE: "下一頁",
    PREV_PAGE: "上一頁",
    ON: "開啟",
    OFF: "關閉",
    TITLE: "標題",
    CONTENT: "內文",
    BUTTON: "按鈕",
    OR: "或",
    DISMISS: "返回",
    BACK: "返回",
    REGION: "地區",
    COUNTRY: "國家",
    COUNTRYCOUNT: "國家數量",
    UPDATE: "最後更新時間",
    SEARCH_RESULTS: "搜尋結果",
    DOWNLOAD: "下載",
    UNIT_PL: "人",
    UNIT_MIN: "分",
    UNIT_SEC: "秒",
    UNIT_Y: "年",
    UNIT_M: "月",
    OFFDAY: "休假",
    WORKDAY: "工作日",
    D_0: "星期日",
    D_1: "星期一",
    D_2: "星期二",
    D_3: "星期三",
    D_4: "星期四",
    D_5: "星期五",
    D_6: "星期六",
    LAST_WEEK: "最近一週",
    LAST_MONTH: "最近一個月",
    LAST_THREE_MONTHS: "最近三個月",
    SATRT_DATE: "開始日期",
    END_DATE: "結束日期",
    EMPTY_FILTER: "找不到資料，請嘗試其他篩選條件。",
    EMPTY_ROOM: "請先選擇列表中的聊天室",
    GET_NEW_MESSAGE: "您收到一則新訊息。",
    GET_NEW_LINK: "您收到一個超連結。",
    GET_NEW_FILE: "您收到一個檔案。",
    MSG_OFFLINE: "目前處於離線狀態，若想繼續作業，請重新連線到網際網路。",
    MSG_RECONNECT: "連線已恢復。",
    MSG_ONLOGOUT:
      "由於您已閒置過久，為保障您的資訊安全，系統已將您強制登出，請重新登入。",
    MSG_ONCLOSE: "聊天連線錯誤或中斷，10 秒後嘗試重新連線。",
    MSG_LOGIN_AGAIN: "請重新登入。",
    MSG_YOU: "您",
    MSG_RETRACT: "已收回訊息",
    NEWMSG: "您有新訊息",
    BEFORE_CHANGE_ROOM: "您有未送出的訊息，切換聊天室後將清除這些訊息。",
    DWONLOAD_ERROR: "找不到檔案。",
    DWONLOAD_ERROR401: "權限不足，請先登入。",
    CONNECTION_STATE: "連線狀態",
    DISCONNECTED: "連線中斷，請稍後嘗試。",
    RECONNECTING: "正在重新連線。",
    ISTYPING: "正在輸入",
    AGENTIDLE: "提醒，{roomName} 已超過 {min} 分鐘未回應用戶，請主動聯繫用戶。",
    CONFIRM: "了解",
    TOTAL_ITMES: "共 {total} 項目",
    ATTACHMENT: "附件",
    NEW_VERSION: "新版",
    OLD_VERSION: "舊版",
  },
  RULE: {
    FORMATE_ERROR: "格式錯誤",
    REQUIRED: "必填",
    PASSWORD: "請輸入密碼",
    PASSWORD_AGAIN: "請再次輸入密碼",
    PASSWORD_CONFIRM: "兩次輸入的密碼不一致!",
    PASSWORD_LEN: "長度在 6 到 12 個字元",
    CANNED_KEYWORD: "開頭必須為「#」半形符號，限制2~10字元",
    EMAIL_FORMATE: "請填入正確信箱格式",
    EMAIL_FORMATE2: "請輸入有效的 ASUS 電子郵件",
    PASSWORD_RULE:
      " 注意：長度限制15~20碼，至少包含「數字」、「大寫英文字母」、「小寫英文字母」、「特殊符號」，其中三種。",
  },
  BUTTON: {
    LATER: "稍後",
    RESET: "重置",
    CANCEL: "取消",
    SAVE: "儲存",
    CONFIRM: "確認",
    CREATE: "建立",
    SELECT: "選擇",
    SEND: "送出",
    SETTING: "設定",
    EDIT: "編輯",
    VIEW: "檢視",
    ADD: "新增",
    ACCEPT: "接受",
    REJECT: "拒絕",
    JOIN_ROOM: "已加入聊天室",
    UNJOIN_ROOM: "已拒絕加入聊天室",
    INVITE: "邀請",
    DELETE: "刪除",
    SEARCH: "搜尋",
    MORE: "更多",
    NEXT: "下一步",
    PREV: "上一步",
    BACK: "返回",
    CHANGE: "變更",
    CHANGEPSW: "變更密碼",
    EXPORT: "匯出",
    SELECT_EXPORT: "選取匯出",
    IMPORT: "匯入",
    UPLOAD: "上傳",
    UPDATE: "立即更新",
    PUBLISHED: "立即發布",
    SCHEDULE: "排程",
    ACTION: "操作",
    MANAGE: "管理",
    MONITOR: "監控",
    TRANSFER: "手動轉接",
    AUTOTRANSFER: "自動轉接",
    SELECTFILE: "選擇檔案",
    GSM_SEARCH: "GSM 查詢",
    HISTORY_LOG: "查看對話紀錄",
    CUSTOMER_CREATE_EDIT_NOTE: "編輯/建立備註",
    BACK_LOGIN: "回登入頁",
  },
  FORM: {
    TO: "至",
    STARTTIME: "開始時間",
    ENDTIME: "結束時間",
    STARTDATE: "開始日期",
    ENDDATE: "結束日期",
    OPT_PUBLISHED: "已發布",
    OPT_UNPUBLISHED: "未發布",
    OPT_RECALL: "已下架",
    OPT_EXPIRED: "已逾期",
    OPT_GENERAL: "一般公告",
    OPT_URGENT: "緊急公告",
    OPT_NONSERVICE: "非服務時間",
    OPT_EC_GENERAL: "電商-一般公告",
    OPT_EC_URGENT: "電商-緊急公告",
    OPT_EC_NONSERVICE: "電商-非服務時間",
    OPT_YES: "是",
    OPT_NO: "否",
  },
  MODULE: {
    LOADINGOPTIONS: "載入選項中...",
    SELECT_ALL: "全選",
    SELECT_REGION: "選擇區域",
    SELECT_COUNTRY: "選擇國家",
    SELECT_REGION_FIRST: "請先選擇區域",
    SELECT_COUNTRY_FIRST: "請先選擇國家",
    SELECT_SKILL: "選擇技能",
    SELECT_AGENT: "選擇專員",
    SELECT_STATUS: "選擇狀態",
    COUNTRY_NOASP: "此國家尚未建立服務商",
    COUNTRY_NOSKILL: "此國家尚未建立技能資料",
    SELECT_ASP: "選擇服務商",
    SELECT_ASP_FIRST: "請先選擇服務商",
    ASP_NOSKILL: "此服務商尚未新增技能資料",
  },
  NOTIFICATION: {
    STATUS_CHANGE_SUCCESS: "變更狀態成功。",
    LOGIN_FAIL: "登入失敗",
    LOGIN_EXPIRE: "密碼過期，請重新設置。",
    LOGIN_SUCCESS: "歡迎回來 ",
    LOGOUT_SUCCESS: "登出成功",
    VERIFY_ERROR: "驗證碼輸入錯誤，請重新輸入。",
    SYS: "系統",
    CONFIRM: "確定",
    CANCEL: "取消",
    LOGOUT: "登出",
    DELETE: "刪除",
    SUCCESS: "成功",
    ERROR: "錯誤",
    NOTICE: "提示",
    ALERT: "警告",
    NODATA: "找不到資料",
    SOMETHING_WENT_WRONG: "發生未知錯誤。",
    CREATE_SUCCESS: "資料已新增成功",
    SEND_SUCCESS: "資料已成功送出",
    UPDATE_SUCCESS: "資料已更新",
    SAVE_SUCCESS: "資料已成功儲存",
    DELETE_SUCCESS: "資料已成功刪除",
    SCHEDULE_SUCCESS: "資料已排程成功",
    PUBLISH_SUCCESS: "資料已發布成功",
    SETTING_SUCCESS: "資料已設定成功",
    PASSWORD_CHANGE_SUCCESS: "密碼已成功變更，下次登入請使用新密碼。",
    SELECT_READY_AGENT: "請優先選擇已上線的專員",
    CONFIRM_LOGOUT_1: "聊天正在進行中，您確定要登出嗎？",
    CONFIRM_LOGOUT_2: "確認要登出嗎？",
    CONFIRM_DELETE: "確認要刪除嗎？",
    CONFIRM_DELETE_SKILL: "確認要刪除此技能嗎？",
    CONFIRM_DELETE_NOTES: "確認要刪除此備註嗎？",
    CONFIRM_DELETE_ASP: "確認要刪除此服務商嗎？",
    CONFIRM_DELETE_BULLETIN: "確認要刪除此公告嗎？",
    CONFIRM_DELETE_COUNTRY: "確認要刪除此國家嗎？",
    CONFIRM_DELETE_CANNED: "確認要刪除此罐頭訊息嗎？",
    CONFIRM_PUBLISH: "確認要立即發布公告嗎？",
    CONFIRM_SCHEDULE: "確認建立公告進入排程嗎？",
    CONFIRM_CREATE_COUNTRY: "確認要新增此地區嗎？",
    CONFIRM_CREATE_ASP: "確認要新增此服務商嗎？",
    CONFIRM_CREATE_SKILL: "確認要新增此技能嗎？",
    CONFIRM_CREATE_ACC: "確認要新增此帳戶嗎？",
    CONFIRM_LEAVE_GROUP: "離開群組後你將無法收到該群組訊息推播。",
    CONFIRM_LEAVE_GROUP_MSG: "確定離開此群組嗎？",
    CONFIG_ANGENT_UNSEND: "此地區系統未允許專員收回訊息。",
  },
  NAV: {
    HOME: "首頁",
    CHAT: "聊天室",
    HISTORY: "對話紀錄",
    CHATCASE: "對話案件",
    REPORT: "報告",
    ACD_MONITOR: "ACD 監控",
    DASHBOARD: "儀錶板",
    SETTING: "設定",
    NOTIFY: "通知",
  },
  LOGIN: {
    EMAIL: "信箱",
    PSW: "密碼",
    REMEMBER: "記住我",
    LOGIN: "登入",
    FORGET_PSW: "忘記密碼",
    ENTER_EMAIL: "請輸入您的電子信箱",
    ENTER_PSW: "請輸入新密碼",
    ENTER_PSW2: "請再次輸入新密碼",
    RESET_SUCCESS: "密碼重設成功",
    RESET_SUCCESS_INFO: "請使用新密碼登入",
    ENTER_VALIDATE_CODE: "請輸入驗證碼(不分大小寫)",
    SENT_1: "重設密碼連結，已寄送至您的信箱",
    SENT_2: "已發送信件至",
    SENT_3:
      "請前往查看您的信箱，若信件未出現在收件匣，請試試到垃圾信件查看。(您可以關閉此頁面)",
    ENTER_CODE: "輸入驗證碼",
    CODE_SENT: "驗證信已寄出",
    RESENT: "重新發送",
    VERIFY_FAIL: "驗證失敗",
  },
  HOME: {
    SERVICE_SKILL: "您的服務技能",
    ORDER_RATE: "建單率",
    WORK_ASSIGNMENT: "今日時間分配",
    CHART_WORK: "工作",
    CHART_BREAK: "休息",
    PICKUP_RATE: "即時狀態",
    TH_SKILL: "技能",
    TH_INLINE: "已進線人數",
    TH_ONLINE: "排隊人數",
    TH_SERVICED: "已服務人數",
    TH_PICKUPRATE: "貢獻度",
    SAT: "用戶對你的滿意度",
    TH_SAT: "滿意",
    TH_UNSAT: "不滿意",
    CODE: "今日二次電子郵件驗證碼",
  },
  CHAT: {
    CL: {
      TITLE: "用戶聊天室",
      MYCLIENT: "我的用戶",
      IDLE: "結束",
      NO_CLIENT: "尚無來自用戶的通知",
      ISSERVICE: "開始執機",
      HEAD: {
        TRIGGER_SURVEY: "觸發滿意度調查",
        SURVEY_TEXT: "{agent} 已送出滿意度調查",
        TRIGGER_IDLE: "觸發閒置提醒",
        TRANSFER: "轉接",
        FINISH: "終止與用戶對話",
        BLACK: "提交黑名單",
        NOTE: "用戶備忘錄",
        COPY_BTN: "複製聊天內容",
      },
      FINISH: {
        TITLE: "結束對話",
        REASON: "結束對話原因",
        OTHER_REASON: "其他原因",
        REASON_1: "服務已完成",
        REASON_2: "客戶無反應",
        REASON_3: "客戶同意斷線",
        REASON_4: "其他",
        REASON_5: "安排遠端服務",
      },
      TRANSFER: {
        TITLE: "轉接設定",
        REASON: "請選擇轉接原因",
        REASON_1: "用戶指定",
        REASON_2: "錯線(下一步選擇產品線)",
        REASON_3: "重大客訴(轉接Supervisor)",
        REASON_4: "用戶需要Video Call協助",
        REASON_5: "其他",
        REASON_OTHER: "請填寫其他原因",
        F_SKILL: "支援產品線",
        TH_AGENT: "專員名稱",
        TH_SKILL: "產品線",
        TH_STATUS: "狀態",
        SELECAGENT: "選擇專員",
        NO_AGENT: "目前尚無可轉接的專員。",
        SELECTED_AGENT: "已選擇專員",
        UNSELECTED_AGENT: "請選擇轉發專員",
        CONFIRM_SELECTED_AGENT: "確認轉發給",
        A_ING: "請稍候，正在自動轉接",
        M_ING: "請稍候，正在轉接給",
        A_SUCCESS: "系統已自動轉接成功。",
        M_SUCCESS: "已成功轉接給",
        AM_FAIL: "轉接失敗，請重新填寫原因及指派轉接專員",
      },
      NOTE: {
        TITLE: "關於此用戶備註",
        CREATE: "建立新備註",
        EDIT: "編輯備註",
        CREATE_NOTE: "限制100字元",
        TH_DATE: "日期",
        TH_AGENT: "專員",
        TH_CONTENT: "內容",
      },
      INFO: {
        TITLE: "聊天室資訊",
        SUBTITLE_1: "用戶資訊",
        SUBTITLE_2: "詢問產品",
        SUBTITLE_3: "歷史資訊",
        SUBTITLE_4: "用戶備註",
        CU_AVATAR: "大頭貼",
        CU_NAME: "稱呼",
        CU_EMAIL: "電子郵件",
        CU_ORDER_NO: "訂單編號",
        CU_TEL: "聯絡方式",
        CU_TIME: "當地時間",
        CU_LOCAL: "位置",
        CU_DEVICE: "裝置",
        CU_PLATFORM: "平台",
        PD_TYPE: "問題分類",
        PD_SKILL: "產品線",
        PD_SKILL_NUM: "產品型號",
        PD_ID: "序號",
        PD_WARRANTY: "保固範圍",
        PD_WARRANTYEND: "保固到期日",
        PD_WARRANTY_REMOTE: "保固服務(遠端服務相關)",
        PD_REMOTE: "延保服務(遠端服務相關)",
        PROBLEM_NOTE: "問題描述",
        HS_VIEWLOGS: "檢視對話",
        HS_TODAYINLINE: "當日進線次數",
        HS_INLINE: "30天內總進線次數",
        HS_LAST_SKILL: "上次詢問產品線",
        HS_LAST_SKILL_NUM: "上次詢問型號",
        HS_MODEL_QUICKSEARCH: "快速搜尋",
        HS_MODEL_EMPTY: "尚無對話紀錄",
        HS_MODEL_1DAY: "今日",
        HS_MODEL_3DAY: "三日",
        HS_MODEL_7DAY: "七日",
        EDIT_PRODUCT: "編輯產品資訊",
        GSM_INFO: "GSM 資訊",
        SN_LOCK:
          "(SN Locked)此設備不適用於華碩維修申請，請聯繫原經銷商辦理報修。",
        STOLEN:
          "此序號已被註記為遺失機台。為利後續調查，請依循以下處理指示： 1.切勿驚動客戶：請勿直接向客戶提及「遺失」或「贓機」等敏感字眼。 2.內部通報：請立即於工作群組通報現場管理主管。 3.引導送修：請以「需進一步詳細檢測」為由，婉轉引導客戶同意送修或將機台留存，轉交維修中心接手處理。",
      },
    },
    IN: {
      TITLE: "內部聊天室",
      CREATE: {
        TITLE: "建立群組",
        ENTER_GROUPNAME: "請輸入群組名稱",
      },
      INFO: {
        TITLE: "聊天室資訊",
        SUBTITLE_1: "群組名單",
        INVITE: "邀請專員",
      },
      F_SEARCHNAME: "搜尋專員姓名",
      TH_NICKNAME: "暱稱",
      TH_USERNAME: "使用者名稱",
      TH_SKILL: "產品線",
      TH_STATUS: "狀態",
      TH_UNSELECT: "請選擇專員",
      TH_SELECTED: "已選擇名單",
    },
    UPLOAD: {
      TITLE: "上傳檔案",
      DROG: "直接拖曳檔案至此",
      FORMATE: "檔案格式限制",
      SIZE: "最大尺寸",
      TH_NAME: "名稱",
      TH_SIZE: "尺寸",
      TH_TYPE: "格式",
      SELECT_AT_LEAST_IMAGE: "請至少選擇一張圖片",
      SELECT_AT_LEAST_FILE: "請至少選擇一個檔案",
      NOT_SUPPORT: "不支援的檔案格式，請選擇其他檔案！",
      FILE_LIMIT: "部分檔案超過尺寸限制。最大限制 {size}MB",
    },
    LINK: {
      TITLE: "加入超連結",
      TEXT: "輸入文字",
    },
    CANNED: {
      TITLE: "罐頭訊息",
      NO_GROUP: "尚未建立群組",
      SELECT_GROUP: "選擇群組",
      SELECT_GROUP_FIRST: "請先選擇群組",
      NO_CATE: "尚未建立分類",
      SELECT_CATE: "分類",
      ENTER_KEYWORD: "輸入關鍵字過濾",
      ENTER_SHORTCUT: "輸入關鍵字搜尋",
      ENTER_SHORTCUT_OR_GROUP: "請輸入關鍵字或選擇群組",
      NO_CANNED: "尚未建立罐頭訊息",
    },
    CHATCASE: {
      PROBLEM: {
        COPY_KB: "複製及引用",
        COPY_SUCCESS: "KB 已存入剪貼簿",
        CLOSE: "關閉",
        SELECT: "引用",
      },
      CREATE_CHATCASE: {
        ALERT: "提示：尚未選擇KB",
      },
    },
  },
  HISTORY: {
    TITLE: "聊天室歷史紀錄",
    NAV_TITLE1: "用戶對話紀錄",
    NAV_TITLE2: "內部對話紀錄",
    NAV_TITLE3: "聊天對話搜尋",
    NAV_TITLE4: "Video Call 用戶紀錄",
    KEYWORDL: "關鍵字",
    TH_DATE: "日期",
    TH_STARTTIME: "開始時間",
    TH_CUST: "客戶名稱",
    TH_CUSTASUSACC: "ASUS 帳號",
    TH_PRODUCT: "產品",
    TH_PHONE: "客戶電話",
    TH_EMAIL: "客戶電子郵件",
    TH_SN: "序號",
    TH_SESSIONID: "對話ID",
    TH_ROOMID: "聊天室ID",
    TH_GROUPNAME: "群組名稱",
    TH_CREATOR: "建立者",
    TH_AGENTNAME: "客服姓名",
    TH_AGENTEMAIL: "客服Email",
    TH_TALKTIME: "交談時間(s)",
    COPY_BTN: "複製聊天內容",
    COPY_SUCCESS: "已將聊天室內容存入剪貼簿。",
    SELECT_TYPE: "請選擇匯出格式。",
  },
  CHATCASE: {
    TITLE: "聊天案件(Beta)",
    TEMP: "暫存草稿，尚未儲存",
    CREATE_CASE: "建立案件",
    EDIT_CASE: "編輯案件",
    DATE: "日期",
    COUNTRY: "國家",
    SKILL: "產品",
    CHAT_HISTORY: "對話紀錄",
    SESSION_NO: "Session No.",
    AGENTNAME: "專員名稱",
    LASTSAVETIME: "儲存時間",
    SUBMITTIME: "提交時間",
    STATUS: "狀態",
    CASE_STATUS: "案件狀態",
    CASE_STATUS_NEW: "開啟",
    CASE_STATUS_FINISHED: "關閉",
    CASE_STATUS_REQUIRED: "案件狀態未填寫",
    SPECIAL_FLAG_L2: "已諮詢L2",
    ROOM_CHANGED: "聊天室已切換，建單資料已重新載入，請確認後再送出。",
    CASENO: "單號",
    CMSSERVER: "CSM Server",
    ACTION: "動作",
    DRAFT: "Draft",
    SUBMITTED: "Done",
    UNSUBMITTED: "未提交",
    EDIT: "編輯",
    BASIC_INFO: "基本資料",
    AGENT_NAME: "專員名稱",
    CLIENT_NAME: "客戶名稱",
    PHONE: "電話",
    EMAIL: "電子信箱",
    PRODUCT: "產品",
    PRODUCT_SN: "請輸入產品序號",
    RMANO: "RMA No.",
    TOPIC: "Topic",
    PROBLEM: "問題",
    SOLUTION: "解決方案",
    DATAREADY: "資料已帶入",
    OS: "OS",
    BTN_DRAFT: "存為草稿",
    BTN_SEND: "送出",
    COPY_CASENO: "單號已存入剪貼簿",
    CASE_CREATED: "聊天案件已建立",
    SN_ERROR: "請輸入正確的產品序號。",
    SN_ERROR2: "非正確序號，將以空值送出。",
    CATA_ERROR: "序號正確，請選擇產品線 (STW failed)",
  },
  REPORT: {
    NAV: {
      TITLE: "報告",
      AGENTSATUS: "專員狀態",
      AGENT_DAILYSATUS: "專員每日狀態",
      AGENT_DAILYSATUS_CHART: "專員每日狀態圖表 (Beta)",
      AGENT_KPIOCCUPANCY: "專員 KPI 與占用率 (Beta)",
      CSAT: "滿意度報告",
      OVERALL_AGENT_SATISFACTION: "整體專員滿意度報表 (Beta)",
      OVERALL_SKILL_SATISFACTION: "整體產品線滿意度報表 (Beta)",
      COST: "費用計算",
      COST_REPORT: "費用報告",
      VIDEO_COST_REPORT: "Video Call 費用報告",
      COST_HOURLY: "每小時服務人數統計",
      KPI: "KPI",
      KPI_REPORT: "KPI 報告",
      KPI_REPORT_SKILL: "KPI 技能視圖",
      KPI_REPORT_HOURLY: "KPI 報告 (每小時)",
      KPI_REPORT_SKILL_HOURLY: "KPI 技能視圖 (每小時)",
      AHT_REPORT: "AHT 報告",
      AHT_REPORT_SKILL: "AHT 技能視圖",
    },
    TH_DATE: "日期",
    TH_AGENT: "專員名稱",
    TH_CLIENT: "客戶名稱",
    TH_SKILL: "技能",
    TH_STARTTIME: "開始時間",
    TH_ENDTIME: "結束時間",
    TH_STATUS: "狀態",
    TH_DURATION: "期間",
    TH_CHAT: "Chat",
    TH_CHATTIME: "[C] 對話時間(分)",
    TH_REAYTIME: "[R] 就緒時間(分)",
    TH_ACWTIME: "[ACW] ACW 時間(分)",
    TH_AUXTIME: "[AUX] AUX 時間(分)",
    TH_LOGINTIME: "[L] 登入時間(分) (R+C+ACW_AUX)",
    TH_TOTALCHAT: "[TC] 全部對話時間(分)",
    TH_OCCUPANCY: "佔用 (C/L)",
    TH_CONCURRENCY: "Concurrency (TC/L)",
    TH_AHT: "AHT",
    TH_CSAT: "滿意度",
    TH_CHANNEL: "平台",
    TH_WAITTIME: "等候時間(秒)",
    TH_CUSTOMEREMAIL: "用戶電子郵件",
    TH_CUSTOMERLOCATION: "用戶所在地",
    TH_TALKTIME: "交談時間",
    TH_USERTALK: "是否交談",
    TH_COUNTRY: "國家",
    TH_ASP: "服務商",
    TH_CHATOFFERED: "已提供交談服務",
    TH_CHATANS: "已回答",
    TH_ANSRATE: "回答率",
    TH_QTYABD: "QTY 放棄",
    TH_ABDRATE: "放棄率 %",
    TH_QUEUED: "排隊",
    TH_MAX_TIMETOANS: "最大答覆時間",
    TH_AVG_TIMETOANS: "平均答覆時間",
    TH_MAX_TIMETOABD: "最大拋棄時間",
    TH_AVG_TIMETOABD: "平均拋棄時間",
    TH_AVG_CHATTIME: "平均交談時間",
    TH_SKILLSLA: "技能 SLA",
    TH_SLA60S: "SLA 60 秒 %",
    TH_CHAT_RECONNECTS: "重連數",
    TH_CHAT_RECONNECTS_RATE: "重連百分比%",
    EXPORT_REGION: "匯出ALL",
    OPT_SAT: "請選擇滿意度",
    OPT_SAT_ALL: "不限",
    OPT_SAT_SATISFIED: "滿意",
    OPT_SAT_DISSATISFIED: "不滿意",
  },
  ACD: {
    TITLE: "即時監控",
    AGENTSTATE: "專員狀態",
    SERVICELEVEL: "服務等級",
    SUMMARY: "摘要",
    TH_HANDLETIME: "處理時間",
    TH_AGENT: "專員",
    TH_SKILL: "技能",
    TH_STATUS: "狀態",
    TH_STATEDURATION: "狀態持續時間",
    TH_CURRENTNUM: "目前人數",
    TH_MAXNUM: "最大可接人數",
    TH_PICKUPNUM: "累計已接人數",
    TH_IDLETIME: "閒置時間",
    TH_INCOMING: "進線人數",
    TH_ANS: "已回覆",
    TH_ANSRATE: "回覆率",
    TH_SLA: "SLA",
    TH_SLARATE: "SLA %",
    TH_QUEUED: "排隊人數",
    TH_MAXWAITING: "最大等待時間",
    TH_DISCSAT_COUNT: "不滿意",
    TH_CSAT_COUNT: "滿意",
    TH_CSAT: "滿意度",
    TH_AHT: "AHT",
    TH_CHATID: "聊天室ID",
    TH_PRODUCT: "產品",
    TH_CUSTOMERNAME: "用戶名稱",
    TH_STARTTIME: "開始時間",
    TH_DURATION: "持續時間",
    TH_LASTMESSAGETIME: "最後傳訊時間",
    TH_IDLE: "閒置",
    F_AGENTSETTING: "專員設定",
    F_AGENTID: "專員 ID",
    F_AGENT: "專員名稱",
    F_SKILL: "支援產品線",
    F_SUPPORTNUM: "支援 Chat 數",
    D_USERCHATLIST: "即時聊天室列表",
    D_CHATROOMINFO: "聊天室資訊",
    D_NOCHAT: "目前沒有正在進行的會話",
    D_PRODUCT: "產品",
    D_PRODUCT_SN: "產品SN",
    D_PROBLEMTYPE: "問題類型",
    D_C_NAME: "用戶名稱",
    D_C_PHONENUM: "聯絡電話",
    D_C_EMAIL: "電子郵件",
    D_C_EMPTY: "空",
    D_C_NOTE: "用戶問題簡述",
    BTN_RESET_SKILL: "技能重置",
    RESET_CONFIRM1: "確定要重置所有專員的技能嗎？",
    RESET_CONFIRM2: "確定要重置專員的技能嗎？",
    RESET_SUCCESS: "專員技能已重設。",
    FORCE_LOGOUT: "強制登出",
    FORCE_SET_AGENT_LOGOUT: "將專員登出系統",
    FORCE_LOGOUT_CONFIRM: "確認要將此專員強制登出嗎？",
    FORCE_LOGOUT_SUCCESS: "專員已被登出。",
    QUEUE_NOTICE1: "有用戶進線排隊",
    QUEUE_NOTICE2: "當前排隊總人數",
  },
  DASHBOARD: {
    TITLE: "儀錶板",
    CLOSED_CASE: "已結束案件",
    INPROCESS_CASE: "處理中案件",
    AGENT_SATUS: "專員狀態",
    SAT: "滿意度統計",
    C_AGENT_OL: "專員斷線",
    C_AGENT_OL_I: "說明(專員斷線)",
    C_CLIENT_OL: "用戶斷線",
    C_CLIENT_OL_I: "說明(用戶斷線)",
    C_TIMEOUT_OL: "系統超時斷線",
    C_TIMEOUT_OL_I: "說明(系統超時斷線)",
    C_OTHER_OL: "其它原因斷線",
    C_OTHER_OL_I: "說明(其它原因斷線)",
    C_AHT_MORE60: "離AHT還有一分鐘以上",
    C_AHT_MORE60_I: "說明(離AHT還有一分鐘以上)",
    C_AHT_IN60: "離AHT小於一分鐘以內",
    C_AHT_IN60_I: "說明(離AHT小於一分鐘以內)",
    C_AHT_OVER: "超過AHT",
    C_AHT_OVER_I: "說明(超過AHT)",
    C_A_READY: "就緒",
    C_A_READY_I: "說明(就緒)",
    C_A_ACW: "ACW",
    C_A_ACW_I: "說明(ACW)",
    C_A_BREAK: "AUX-休息",
    C_A_BREAK_I: "說明(AUX-休息)",
    C_A_MEETTING: "AUX-會議",
    C_A_MEETTING_I: "說明(AUX-會議)",
    C_SAT: "滿意",
    C_SAT_I: "說明(滿意)",
    C_UNSAT: "不滿意",
    C_UNSAT_I: "說明(不滿意)",
    C_NOSAT: "未進行滿意度調查",
    C_NOSAT_I: "說明(未進行滿意度調查)",
    TH_STATUS: "狀態",
    TH_AGENTNAME: "專員",
    TH_CUSTOMER: "用戶",
    TH_SAT: "滿意",
    TH_UNSAT: "不滿意",
    TH_HANDLETIME: "處理時間",
    TH_STARTTIME: "開始時間",
    TH_SURVEYTIME: "調查作答時間",
    TH_SURVEYCODE: "作答結果",
  },
  SETTING: {
    INDEX: {
      PERSONAL_SETTING: "個人設定",
      PERSONAL_EDIT_PROFILE: "編輯個人資料",
      PERSONAL_EDIT_CANNEDRESPONSE_SETTING: "個人罐頭訊息設定",
      PUBLIC_CANNEDRESPONSE_LIST: "公用罐頭訊息列表",
      CHAT_SETTING: "對話設定",
      CHAT_BASIC_SETTING: "基本設定",
      CHAT_SYSTEM_COPYWROTIN_SETTING: "系統文案設定",
      CHAT_CANNEDRESPONSE_SETTING: "公用罐頭訊息設定",
      CHAT_BULLETIN_SETTING: "站外公告設定",
      BULLETIN_SETTING: "站內公告",
      NOTIFY_SETTING: "通知設定",
      COUNTRY_SETTING: "國家設定",
      ASP_SETTING: "服務商設定",
      SKILL_SETTING: "技能設定",
      SKILL_COUNTRY_SETTING: "國家技能設定",
      SKILL_REGION_SETTING: "公共技能設定",
      SKILL_SCHEDULE_SETTING: "技能假期預排",
      ACCOUNT_SETTING: "帳號設定",
      EC_LOGIN: "電商設定-會員登入開關",
      GPT_SETTING: "ChatBot",
    },
    PERSONAL: {
      PROFILE: {
        TITLE: "編輯個人資料",
        ACC_INFO: "帳號資訊",
        ACC: "帳號",
        EMAIL: "信箱",
        USERNAME: "使用者名稱",
        CURRENTPSW: "現在密碼",
        NEWPSW: "新密碼",
        NEWPSW2: "再次輸入新密碼",
        BASIC_SETTING: "基本設定",
        AVATAR: "大頭貼",
        UPLOAD_AVATAR: "上傳/更改大頭貼",
        NAME: "姓名",
        FIRSTNAME: "名",
        LASTNAME: "姓",
        NICKNAME: "暱稱",
        GENDER: "性別",
        MALE: "男",
        FEMALE: "女",
        LAN: "語系",
        KBLAN: "KB 偏好語系",
      },
    },
    CANNED: {
      PERSONAL_CANNED_SETTING: "個人罐頭訊息設定",
      EDIT_PERSONAL_CANNED: "編輯個人罐頭訊息",
      EDIT_PUBLIC_CANNED: "編輯公共罐頭訊息",
      CREATE_PERSONAL_CANNED: "建立個人罐頭訊息",
      CREATE_PUBLIC_CANNED: "建立公用罐頭訊息",
      EDIR_GROUP: "編輯自定義群組",
      CREATE_CANNED: "建立罐頭訊息",
      IMPORT_CANNED: "匯入罐頭訊息",
      EXPORT_CANNED: "匯出全部罐頭訊息",
      SELECT_FILE: "請選擇檔案",
      DOWNLOAD_SAMPLE: "下載範例檔",
      CREATE_GROUP: "建立群組",
      CREATE_CATE: "建立分類",
      EDIT_GROUP: "編輯群組",
      EDIT_CATE: "編輯分類",
      GROUP_NAME: "群組名稱",
      CATE_NAME: "分類名稱",
      SELECTED_FILE: "已選擇檔案",
      SELECT_GROUP: "選擇群組",
      SELECT_GROUP_FIRST: "請先選擇群組",
      SELECT_CATE: "選擇分類",
      ENTER_SHORTCUTS: "輸入關鍵字",
      TH_GROUP: "群組",
      TH_CATE: "分類",
      TH_SHORTCUTS: "關鍵字",
      TH_CONTENT: "訊息內容",
      TH_CREATOR: "建立者",
      TH_ACTION: "動作",
      EMPTYTEXT: "尚未建立任何罐頭訊息",
      SHORTCUT_INFO:
        "要在對話期間使用罐頭訊息，請輸入 # 和關鍵字。您也可以使用逗號分隔關鍵字，替同一段訊息設定多個關鍵字。",
      NO_GROUP: "尚未建立群組",
      NO_CATE: "尚未建立分類",
      BEFORE_DELETE_CANNED: "確認刪除此罐頭訊息嗎?",
      BEFORE_DELETE_CATE: "確認刪除分類嗎?",
      BEFORE_DELETE_GROUP: "確認刪除群組嗎?",
      PUBLIC_CANNED_SELECT_COUNTRY: "公用罐頭訊息設定 - 選擇國家",
      PUBLIC_CANNED: "公用罐頭訊息",
      MANAGE_GROUP: "管理產品分類",
      AGENT_CANNED: "專員罐頭訊息",
      IDLE_QUICK: "快速回覆",
    },
    CHAT: {
      BASIC: {
        CHATLIST_FILTER: "聊天室列表撈取優化",
        CHATLIST_FILTER_INTRO:
          "開啟後，專員的聊天室列表改為載入所有未結束的聊天室、結束時間在設定的保留時間內的已結束聊天室，不再撈取當天全部聊天室。",
        SELECT_COUNTRY: "對話基本設定 - 選擇國家",
        TITLE: "對話基本設定",
        TRANSFER: "檔案傳輸",
        FILE_TYPE: "檔案支援格式",
        IMAGE_TYPE: "圖檔支援格式",
        AGENT_SEND_FILE: "允許專員傳送「檔案」給用戶",
        AGENT_SEND_IMAGE: "允許專員傳送「圖片」給用戶",
        AGENT_FILE_LIMIT: "專員「檔案」傳輸最大限制",
        AGENT_IMAGE_LIMIT: "專員「圖片」傳輸最大限制",
        PIC_ENCRYPTED: "圖片是否加密",
        CLIENT_SEND_FILE: "允許用戶傳送「檔案」給專員",
        CLIENT_SEND_IMAGE: "允許用戶傳送「圖片」給專員",
        CLIENT_FILE_LIMIT: "用戶「檔案」傳輸最大限制",
        CLIENT_IMAGE_LIMIT: "用戶「圖片」傳輸最大限制",
        AGENT_DELETE_MSG: "允許專員回收訊息",
        AUTO_DAYLIGHT_SAVING: "自動調整日光節約時間",
        PICKUP_TIME: "緩衝時間(秒)",
        SHOW_SURVEY_RUIE1: "顯示問卷條件(時間)(秒",
        SHOW_SURVEY_RULE1_INTRO:
          "對話時間少於指定時間(秒)就代表用戶只進線沒有對話，不顯示問卷調查。",
        SHOW_SURVEY_RUIE2: "顯示問卷條件(訊息)(則)",
        SHOW_SURVEY_RULE2_INTRO:
          "對話內容少於指定數量就代表用戶只進線沒有對話，不顯示問卷調查。",
        SHOW_SURVEY_RUIE3: "顯示問卷條件(訊息)",
        SHOW_SURVEY_RULE3_INTRO: "若用戶沒有傳送訊息，則不顯示問卷調查。",
        AGENT_IDLE_TIMEOUT: "閒置提醒",
        AGENT_IDLE_TIMEOUT_INTRO:
          "正在進行的聊天室，專員超過設定的時間未回覆客戶。",
        IS_AGENT_IDLE: "僅當客戶端發送最後一則訊息時才會觸發空閒提醒。",
        VIDEOCALL_SETTING: "Video Call 設定",
        ISRMANO: "RMA No. 必填",
        URL_SETTING: "網址設定",
        OFFICIAL_URL: "官網網址設定",
        ACCOUNT_URL: "登入網址設定",
      },
      COPYRIGHT: {
        SELECT_COUNTRY: "系統文案設定 - 選擇國家",
        TITLE_BEFORECHAT: "系統文案設定 - 對話前",
        TITLE_ONCHAT: "系統文案設定 - 聊天室內",
        TITLE_SAT: "系統文案設定 - 滿意度",
        TITLE_EC_SAT: "系統文案設定 - 電商滿意度設定",
        TITLE_VIDEOCALL: "系統文案設定 - Video Call 設定",
        TAB: {
          BEFORECHAT: "對話前宣告與公告事項",
          ONCHAT: "聊天室內介紹與轉接",
          SAT: "滿意度調查選項設定",
          EC_TITLE: "電商滿意度設定",
          VIDEOCALL: "Video Call 設定",
        },
        BEFORECHAT: {
          COPYRIGHT: "隱私權宣告",
          SAT_CONSENT: "滿意度回訪同意書",
          WELCOME: "歡迎語",
          BBY: "BBY宣告",
          NOSERVICE: "非服務時間",
          SERVICE: "服務時間公告",
          UNSERVICE: "暫停服務",
          BUSY: "專員忙線中",
          AGE_CHECK: "電商入口年齡審核",
          AGE_LIMIT: "年齡限制",
          NonServiceProduct: "非服務產品線",
        },
        SERVICE_TYPE: {
          TITLE: "服務類型設定",
          OPTION: "選項",
          SN: "SN 檢核",
          SN_CHECK: "僅接受持有有效序號的用戶進行服務。",
        },
        ONCHAT: {
          SELFINTRO: "專員自我介紹",
          SELFINTRO_INFO:
            "範例：您好！我是線上客服專員 {Agent_Name}，很高興為您服務。請問有什麼地方可以協助您？",
          IDLE_NOTICE: "用戶閒置預告",
          IDEL_NOTICE_TIME: "閒置時間(s)",
          IDEL_NOTICE_TIME_INTRO:
            "用戶閒置超過系統所設定時間，顯示閒置訊息。（單位:秒）",
          IDLE_DISCONNECT: "用戶閒置斷線",
          IDLE_DISCONNECT_TIME: "斷線時間(s)",
          IDLE_DISCONNECT_TIME_INTRO:
            "用戶斷線超過系統所設定時間，顯示斷線訊息。（單位:秒）",
          TRANSFER_AGENT: "轉接自我介紹",
          TRANSFER_AGENT_INTRO:
            "範例：您好！我是負責 {Skill_Name}的專員 {Agent_Name}，很高興為您服務。請問有什麼地方可以協助您？",
          BEFOREFINISH: "終止服務提示",
          AGENT_DISCONNECT: "專員主動斷線",
          CHAT_EXPORT: "對話紀錄輸出",
          BUTTON_1: "按鈕1",
          BUTTON_2: "按鈕2",
          BUTTON_PLACEHOLDER: "請輸入按鈕文字",
          FINISH_OPTION_1: "按鈕功能：服務已完成，進行滿意度調查",
          FINISH_OPTION_2: "按鈕功能：聯繫線上客服",
          EXPORT_ALLOW: "是否開放下載",
          EXPORT_WELCOME_TEXT: "下載文件歡迎詞",
          EXPORT_PRIVACY_BTN: "隱私權按鈕設定",
          EXPORT_PRIVACY_LINK: "隱私權連結",
          EXPORT_TERMS_BTN: "使用條款按鈕設定",
          EXPORT_TERMS_LINK: "使用條款連結",
          YOUTUBE_NOTE: "若URL欄位留空，點擊圖示將導向全球 YouTube 頻道：",
        },
        SAT: {
          ISSURVEY: "顯示問卷",
          SATISFIED: "滿意",
          UNSATISFIED: "不滿意",
          PLACEHOLDER: "請輸入原因",
          OPTION: "選項",
          OTHER: "其他",
          OTHER_INFO: "開啟後，在用戶端顯示填寫欄位",
        },
        VIDEOCALL: {
          COPYRIGHT: "隱私權宣告",
          SAT: "滿意度選項設定",
          EMAIL: "Email 設定",
          CONTENT_EXAMPLE_1:
            "在發送給客戶的郵件中會插入 QR Code 圖像、以及帶有連結的Click here圖像。請將下面兩個字串(包含符號 { } )放置在文案中:",
          CONTENT_EXAMPLE_2: "1. {qrcode_image} 放在想要顯示 QR Code 的位置",
          CONTENT_EXAMPLE_3:
            "2. {qrcode_link} 放在要顯示 'Click here' 的文字旁邊",
        },
      },
      BULLETIN: {
        SELECT_COUNTRY: "公告設定 - 選擇國家",
        TITLE_LIST: "公告設定",
        TITLE_CREATE: "建立公告",
        TITLE_EDIT: "編輯公告",
      },
    },
    BULLETIN: {
      SELECT_COUNTRY: "站內公告設定 - 選擇國家",
      TITLE_LIST: "站內公告設定",
      TITLE_CREATE: "建立站內公告",
      TITLE_EDIT: "編輯站內公告",
      FORM_DATE: "公告建立日期",
      FORM_TO: "至",
      FORM_STARTDATE: "開始日期",
      FORM_ENDDATE: "結束日期",
      FORM_CATEGORY: "分類",
      FORM_CATE_GENERAL: "一般公告",
      FORM_CATE_EMERGENCY: "緊急公告",
      FORM_CATE_NONSERVICE: "非服務時間公告",
      FORM_STATUS: "狀態",
      FORM_UNPUBLISHED: "未發布",
      FORM_PUBLISHED: "已發布",
      TH_DATE: "建立時間",
      TH_CONTENT: "內容",
      TH_CATEGORY: "分類",
      TH_COUNTRY: "國家",
      TH_STATUS: "狀態",
      TH_STARTTIME: "排程開始時間",
      TH_ENDTIME: "排程結束時間",
      C_SELECT_COUNTRY: "選擇國家",
      C_TARGET: "發布對象",
      C_TARGET_AGENT: "服務專員",
      C_TARGET_CLIENT: "用戶端",
      C_CATEGORY: "訊息分類",
      C_SKILLGROUP: "發送產品線",
      C_CONTENT: "發布內容",
      C_LINK: "連結網址",
      C_ISSCHED: "是否排程",
      C_ISSCHED_YES: "是",
      C_ISSCHED_NO: "否",
      C_SCHED_STARTTIME: "排程開始時間",
      C_SCHED_ENDTIME: "排程結束時間",
      E_STATUS: "是否下架",
      E_STATUS_ACTIVE: "是",
      E_STATUS_INACTIVE: "否",
    },
    NOTICE: {
      SELECT_COUNTRY: "通知設定 - 選擇國家",
      SELECT_ASP: "通知設定 - 選擇服務商",
      TITLE: "通知設定",
      SUBTITLE: "觸發條件與選項設定",
      NOTICE_01: "排隊人數",
      NOTICE_02: "休息時間過長",
      NOTICE_03: "ACW時間過長",
      NOTICE_04: "服務時間無專員上線",
      NOTICE_05: "專員登入/登出通知",
      NOTICE_06: "專員狀態變更",
      NOTICE_07: "專員HT時間過長",
      NOTICE_08: "專員網路異常",
      NOTICE_09: "滿意度不佳(DSAT)",
      NOTICE_10: "進線量異常偵測 (Beta)",
      LABEL_ONOFF: "關閉/開啟",
      LABEL_NOTICETARGET: "通知對象",
      LABEL_LINEUP: "當排隊人數大於",
      LABEL_AUX: "專員狀態為AUX",
      LABEL_ACW: "專員狀態為ACW",
      LABEL_HT: "專員HT時間過長",
      LABEL_TRIGGER: "觸發門檻",
    },
    COUNTRY: {
      TITLE: "國家列表",
      SELECT_COUNTRY: "選擇國家",
      EDIT_COUNTRY: "編輯國家",
      COUNTRY_CODE: "國家代碼",
      COUTNRY_NAME: "國家名稱",
      REGION: "區域",
      TIMEZONE: "時區",
      DST: "日光節約時間",
      ADD_DST: "新增日光節約時間",
      LINK: "連結",
      COPY_LINK_SUCCESS: "連結已存入剪貼簿",
      IS_ASUSLOGIN: "前台客戶是否需要會員登入",
      IS_MAILVERIFY: "Email二次驗證",
    },
    ASP: {
      SELECT_COUNTRY: "服務商設定 - 選擇國家",
      TITLE: "服務商列表",
      TH_COUNTRY: "國家代碼",
      TH_ASPNAME: "服務商名稱",
      TH_ASPSKILL: "技能",
      TH_ASPCOUNT: "服務商數量",
      TH_SUPPORT_COUNTRY: "支援國家",
      TH_ISACTIVE: "是否服務",
      TH_NOTE: "反灰處為跨國支援廠商",
      FORM_TITLE_CREATE: "新增服務商",
      FORM_TITLE_EDIT: "服務商管理",
      FORM_NAME: "服務商名稱",
      FORM_ON: "開啟服務",
      FORM_ON_TIPS: "開啟後該廠商即可提供服務",
      FORM_ITEM: "服務項目",
      FORM_ITEM_TIPS: "服務商提供的服務技能",
      FORM_TRANSFER: "專員之間技能轉接",
      FORM_TRANSFER_TIPS: "若開啟代表隸屬同一服務商之下的專員可以互相技能轉接",
      FORM_TRANSFER_ASP: "可轉接其它服務商",
      FORM_TRANSFER_ASP_TIPS: "轉接至相同國家其它的服務商",
      FORM_TRNASFER_COUNTRY: "跨國支援服務商",
      FORM_TRNASFER_COUNTRY_TIPS: "支援同區域國家服務商服務，若無請留空",
    },
    SKILL: {
      COUNTRY: {
        SELECT_COUNTRY: "國家技能設定 - 選擇國家",
        TITLE: "國家技能管理",
        TH_SINGLE_SERVICE: "單一營業時間",
        TH_SINGLE_SERVICE_INFO:
          "所有技能的服務時間將依照「單一營業時間」的設定",
        TH_SKILL_GLOBAL: "技能(Global)",
        TH_SKILL_TAG: "技能(TAG)",
        TH_SKILL_LOCAL: "當地技能名稱",
        TH_HANDLETIME: "處理時間",
        TH_DAY: "星期",
        TH_TIME: "時段",
        TH_NOTE: "技能服務時段",
        FORM_TITLE_CREATE: "建立技能",
        FORM_TITLE_EDIT: "技能管理",
        FORM_SUBTITLE_1: "技能設定",
        FORM_SUBTITLE_2: "新增服務時間",
        FORM_SUBTITLE_3: "服務時段",
        FORM_SKILL: "技能",
        FORM_SKILL_STATUS: "技能狀態",
        FORM_SKILL_DISPLAY: "顯示",
        FORM_SKILL_HIDDEN: "隱藏",
        FORM_SKILL_LOCAL: "當地技能名稱",
        FORM_HANDLETIME: "技能處理時間",
        FORM_PRODUCT: "產品線",
        FORM_SELECTDAY: "請選擇日期",
        FORM_STARTTIME: "開始時間",
        FORM_ENDTIME: "結束時間",
        FORM_ADD: "加入時段",
        OFFDAY: "休假",
      },
      REGION: {
        TITLE: "公共技能設定",
        SKILL_GLOBAL: "技能(Global)",
        SKILL_TAG: "技能(TAG)",
      },
      SCHE: {
        SELECT_COUNTRY: "技能假期預排 - 選擇國家",
        TITLE: "技能假期預排",
      },
    },
    ACC: {
      TITLE: "帳號管理",
      TITLE_CREATE: "新增帳號",
      TITLE_EDIT: "編輯帳號",
      COUNTRY: "國家",
      USERNAME: "使用者名稱",
      ROLE: "角色權限",
      ASP: "服務商",
      SKILL: "技能",
      WEBRTC: "Video Call Lite",
      EMAIL: "電子郵件",
      IS_FAKE_EMAIL: "虛擬電子郵件",
      CHANGE_PSW: "更改密碼",
      PSW: "密碼",
      PSWCONFIRM: "確認密碼",
      RANDOM_PSW: "產生隨機密碼並複製",
      STATUS: "帳號狀態",
      MAXSERVICECOUNT: "最大服務人數",
      ISSERVICE: "開始執機",
      ISSERVICE_TRANSFER_ONLY: "僅服務轉接用戶",
      MANUAL_TRANSFER_ONLY: "僅限人工轉接",
      ACD_MONITOR: "ACD監控設定",
      USERNAME_INFO: "請輸入至少6-20位英數混和字元",
      PASSWORD_INFO: "請留意密碼格式",
      ACC_SETTING: "帳戶設定",
      BASIC_SETTING: "基本設定",
      AVATAR: "大頭貼",
      UPLOAD_AVATAR: "上傳/更改大頭貼",
      NAME: "姓名",
      FIRSTNAME: "名",
      LASTNAME: "姓",
      NICKNAME: "暱稱",
      GENDER: "性別",
      MALE: "男",
      FEMALE: "女",
    },
    SELECT_COUNTRY: {
      COUNTRYCODE: "國家代碼",
      COUNTRYNAME: "國家名稱",
    },
    EC_LOGIN: {
      TITLE: "電商設定-會員登入開關",
      DESC: "欲開啟/關閉國家會員登入流程，可以透過操作執行，「開啟」客戶需登入才能與客服人員開啟對話 「關閉」客戶將不用登入會員。",
      TH_REGION: "區域",
      TH_COUNTRYNAME: "國家名稱",
      TH_ACTION: "操作",
    },
    GPT: {
      SELECT_COUNTRY: "ChatBot設定 - 選擇國家",
      TITLE: "ChatBot 基本設定",
      SYSTEM: {
        TITLE: "系統文案設定",
        PRIVACY: "隱私權宣告",
        SERVICE_TITLE: "營業/非營業時間公告",
        SERVICE: "營業時間公告",
        NON_SERVICE: "非營業時間公告",
        NON_SERVICE_REPLY: "非營業時間回覆",
        NON_SERVICE_BTN: "選項文案",
        NON_SERVICE_URL: "請輸入URL",
        IDLE: "用戶閒置",
        IDLE_LABEL: "閒置預告提醒(S)",
        IDLE_DESC: "用戶閒置超過系統所設定時間，顯示閒置訊息。（單位:秒）",
        OFFLINE: "用戶斷線",
        OFFLINE_MSG: "用戶閒置斷線訊息",
        OFFLINE_TIME: "斷線時間(S)",
        OFFLINE_DESC: "用戶閒置超過系統所設定時間，顯示斷線訊息。（單位:秒）",
        SENTENCE: "對話次數限制",
        SENTENCE_MSG: "終止服務提示",
        SENTENCE_LABEL: "參數設定(次)",
        SENTENCE_DESC:
          "與BOT對話超過系統所指定的次數上限，顯示終止服務訊息。（單位:次)",
        IP_LIMIT_LABEL: "IP 每日 AI 回覆次數上限(次)",
        IP_LIMIT_DESC:
          "同一 IP 每日呼叫 AI 回覆超過指定次數，顯示終止服務訊息，不影響 Decision Tree。（單位:次)",
        SAT: "用戶不滿意計數器",
        SAT_LABEL: "用戶不滿意計數器",
        SAT_DESC:
          "用戶針對BOT的回覆，累計點選不喜歡到達指定的次數，顯示轉真人服務提示。（單位:次)",
        SAT_SWITCH: "滿意度調查",
        SAT_DISLIKE: "不滿意原因",
        TOAGENT: "觸發轉真人服務",
        TOAGENT_MSG: "轉真人服務提示",
        TOAGENT_LABEL: "次數設定(次)",
        TOAGENT_DESC: "顯示轉真人服務提示。（單位:次)",
        AD: "廣告設定",
        AD_URL: "請輸入URL",
        AD_PIC: "上傳新圖片 (建議尺寸 330*120)",
        AD_NEW: "新增廣告",
        BOT: "BOT對話設定",
        BOT_LABEL: "訊息文案",
        BOT_NEW: "新增文案",
        BOT_WELCOME: "歡迎文案",
        BOT_TEC: "技術支援回覆",
        BOT_PRODUCT: "產品線回覆",
        BOT_BOT: "BOT回覆結果",
        BOT_END: "結束聊天訊息",
        BOT_NOSERVICE: "非服務時間",
        BOT_REPAIR: {
          TITLE: "維修進度回覆設定",
          INPUT: "SN/RMA No.輸入提示文案",
          RECORD: "有維修紀錄",
          NORECORD: "無維修紀錄(未啟用)",
          NOSN: "查無此序號",
          ERRORTIMES: "序號錯誤次數限制",
          TOAGENT: "轉接客服文案",
        },
        BOT_WARRANTY: {
          TITLE: "保固狀態回覆設定",
          INPUT: "SN/RMA No.輸入提示文案",
          RECORD: "有保固結果",
          NORECORD: "無保固結果(未啟用)",
          NOSN: "查無此序號",
          ERRORTIMES: "序號錯誤次數限制",
          TOAGENT: "轉接客服文案",
        },
      },
      DECISION_TREE: "Decision Tree 設定",
      TREE: {
        NORMAL: "一般",
        NAME: "名稱",
        STYLE: "樣式",
        OPTION: "操作",
        EDIT: "編輯",
        SORT: "排序",
        NEWLAYER: "新增階層",
        EDITLAYER: "編輯階層",
        KEYNAME: "意圖",
        TITLE: "標題",
        SUBTITLE: "副標題",
        IS_SURVEY: "滿意/不滿意",
        DISPLAY: "顯示",
        TOAGENT: "僅轉真人服務",
        TOAGENT_DESC: "說明文案",
        TOAGENT_NONSERVICE: "非服務時間客製化回覆",
        LINK_STYLE: "連結樣式設定",
        LINK: "連結設定",
        LINK_BTNTEX: "按鈕文字",
        LINK_BLANK: "開啟新視窗",
        CARD_STYLE: "卡片樣式設定",
        CARD_IMAGE: "圖片",
        CARD_BTNTEXT: "按鈕文字",
        GPTLINK: "產品線",
        CHILD_LAYER_STYLE: "子層清單樣式",
        CHILE_LAYER_OPT1: "文字",
        CHILE_LAYER_OPT2: "連結",
        CHILE_LAYER_OPT3: "連結(BOT)",
        CHILE_LAYER_OPT4: "卡片(連結)",
        CHILE_LAYER_OPT5: "卡片(BOT)",
        CHILD_LAYER_OPT_DESC: "※子層列表所呈現的樣式(若有)",
        CHILD_LAYER_DESC: "子層清單說明",
        TUTORIAL: "引導頁面",
        TUTORIAL_MODE: "引導模式",
        TUTORIAL_INTENT: "意圖",
        TUTORIAL_TITLE: "標題",
        TUTORIAL_CONTENT: "描述",
        TUTORIAL_ICON: "圖示",
        TUTORIAL_NEW: "新增引導",
      },
      SAT: {
        TITLE: "滿意度調查選項設定",
      },
      SN_BLOCK: {
        TITLE: "SN Block List Setting",
      },
    },
  },
  NOTIFY: {
    ROLE: "權限",
    AREA: "地區",
    STATUS_SETTING: "狀態設定",
    LOGIN: "登入/閒置",
    READY: "就緒",
    BREAK: "休息",
    LUNCH: "用餐",
    ACW: "文書作業",
    MEETING: "會議",
    COACHING: "教育訓練",
    LOGOUT: "登出",
  },
  MESSAGECENTER: {
    TITLE: "通知中心",
    NO_MSG: "尚無任何通知",
    CHANGEPSW: "請於 {date} 前，變更新密碼。",
    KB_LAG: "請完成KB偏好語系設定",
    FIRST_CHANGEPSW:
      "為了確保您的帳戶安全，我們建議您定期變更密碼。 請問您是否希望現在就進行密碼變更？ 點擊「確認」來變更密碼，或點擊「稍後」以後再處理。",
  },
  VIDEO: {
    VIDEO_READY: "Video chat has already running.",
    CONFIRM: {
      TITLE: "Start a video  invitation(Beta)",
      TEXT: "Are you sure you want to send the video chat invitation?(Beta)",
      HANGUP: "Hangup",
      HANGUP_TEXT: "Are you sure you want to end the video chat?",
    },
    MESSAGE: {
      INVITE_MSG:
        'You have sent a video invitation to the customer. To cancel the invitation, please click "Cancel Video Invitation"',
      CANCEL_INVITE: "Cancel Video Invitation",
    },
    LAYOUT: {
      DEVICE_NOT_FOUND: "Webcam not found.",
      DEVICE_NOT_FOUND_INFO:
        "Your device was not detected, please make sure you have allowed the website to use your camera and microphone or if the device is already occupied by another application.",
      LOCAL_WEBCAM: "Your stream",
      DRAG: "Click here to drag the window",
      CLIENT_HANGUP: "Client has actively hung up the video connection",
      CLIENT_REFUSES: "The other party declined the video invitation",
    },
  },
  VIDEOCALL: {
    TITLE: "Video Call Lite (Beta)",
    READY: "準備好進行 Video Call",
    ENDED: "Video Call 已結束",
    WAITING: "等待用戶端連線中...",
    IN_PROGRESS: "視訊對話進行中",
    BACK_TO_CURRENT: "返回目前視訊對話",
    RECORD_ING: "錄影中",
    RECORD_PAUSE: "錄影暫停",
    RECORD_END: "錄影結束",
    CREATE: {
      SN_ERROR: "序號不存在",
    },
    CUSTOMER_ENDED: "用戶已結束 Video Call",
    END: "結束 Video Call",
    END_DESC:
      "是否關閉聊天室？按「確認」結束聊天室。 （用戶將無法再透過連結進入聊天室。）",
  },
  FUNNEL: {
    TITLE: "Funnel Chart (Beta)",
    ENTER_URL: "請輸入網址",
    RESULT: "顯示的網頁",
  },
};
export default tw;
